import * as React from 'react';
// mui
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
// redux
import { useSelector, useDispatch } from 'react-redux';
import { AppDispatch } from '../../store/store';
import { selectBaseProjectId, selectSelectedProjectId } from '../../store/selectors/projectSelectors';
import { deleteProject } from '../../store/slices/projectsSlice';
// type
import Project from '../../interfaces/Project.interface';
// axios
import api from '../../axios';

interface DeleteProjectDialogProps {
  onClose: () => void;
  onDelete: (newProjectToSelectId: number | null) => void;
  focusedProject: Project | null;
}

export default function DeleteProjectDialog(props: DeleteProjectDialogProps) {
  // props
  const onCloseCallback = props.onClose;
  const onDeleteCallback = props.onDelete;
  const focusedProject = props.focusedProject;

  // hooks
  const dispatch = useDispatch<AppDispatch>();

  // redux
  const localSelectedProjectId: number | null = useSelector(selectSelectedProjectId());
  const localBaseProjectId: number | null = useSelector(selectBaseProjectId());

  // state
  const [ showConfirmDeleteDialog, setShowConfirmDeleteDialog ] = React.useState<boolean>(true);
  const [ confirmDeleteLoading, setConfirmDeleteLoading ] = React.useState<boolean>(false);

  const handleDeleteProject = () => {
    setConfirmDeleteLoading(true);

    if (focusedProject !== null) {
      api.delete(`/projects/delete/${focusedProject.id}`)
        .then((res) => {
          console.log(res);

          dispatch(deleteProject(focusedProject.id));
          setShowConfirmDeleteDialog(false);

          if (focusedProject.id === localSelectedProjectId) { // if the user was viewing the project being deleted
            onDeleteCallback(localBaseProjectId);
          } else if (localSelectedProjectId === null) {
            onDeleteCallback(localSelectedProjectId);
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          setConfirmDeleteLoading(false);
        });
    } else {
      console.error('Cannot delete project with id NULL!');
      setConfirmDeleteLoading(false);
    }
  }
  
  return (
    <Dialog
      open={showConfirmDeleteDialog}
      onClose={() => { setShowConfirmDeleteDialog(false); onCloseCallback(); }}
    >
      <DialogTitle>
        Delete Project "{focusedProject?.name}"?
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          Deleting this project will delete all of it's tasks and their respective subtasks. This action cannot be undone!
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => { setShowConfirmDeleteDialog(false); onCloseCallback(); }}>Cancel</Button>
        <Button loading={confirmDeleteLoading} onClick={() => { handleDeleteProject(); onCloseCallback(); }} autoFocus>
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
}